import React from 'react';

const TestimonialData =  {
        id: "01",
        form: "Poland",
        description: "What I am primarily looking for with new projects is a fit on both a visual and aesthetic level as well as on a personal level with the client.",
        name: "John Due",
        subtitle: "App Developer",
        image: "testimonial-dark-01",
    }



const TestimonialTwo = ({column , teamStyle}) => {
    return (
        <div className="row">
            <div className={`${column}`}>
                <div className={`testimonial-style-two ${teamStyle}`}>
                    <div className="row align-items-center row--20">
                        <div className="order-2 order-md-1 col-lg-12 col-md-12 offset-lg-1">
                            <div className="content">
                            <div className="inner text-center">
              <h1 className="title">
                <span className="theme-gradient">                    Solo hay algo peor que entrenar a tus empleados y que se
                    vayan. <br/>No formarlos y que se queden.</span>
              </h1>
              <h3><span className="theme-gradient">  - Dan Panini</span></h3>
            </div>
                                <div className="client-info">
                                
                                    <h6 className="subtitle">{TestimonialData.subtitle}</h6>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        
    )
}
export default TestimonialTwo;